import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedComponentsModule } from '../shared/directives/shared-components.module';
import { IconFontModule } from '../shared/icon-font/icon-font.module';
import { InstrumentationModule } from '../shared/instrumentation/instrumentation.module';
import { ResizeModule } from '../shared/resize/resize.module';
import { TitleAnnouncerModule } from '../shared/title-announcer/title-announcer.module';
import { CarouselCardComponent } from './card/carousel-card.component';
import { CarouselComponent } from './carousel.component';

@NgModule({
    imports: [
        CommonModule,
        IconFontModule,
        TitleAnnouncerModule,
        InstrumentationModule,
        ResizeModule,
        SharedComponentsModule
    ],
    declarations: [
        CarouselComponent,
        CarouselCardComponent
    ],
    exports: [
        CarouselComponent
    ]
})
export class CarouselModule {
}
